import { useState } from 'react';

export interface MemberDetailsContext {
  isResetCurrentPage: boolean;
  onResetCurrentPage: (isReset: boolean) => void;
}

export const useMemberDetailsContext = () => {
  const [isResetCurrentPage, setIsResetCurrentPage] = useState<boolean>(false);

  const context: MemberDetailsContext = {
    isResetCurrentPage,
    onResetCurrentPage: setIsResetCurrentPage
  };

  return {
    context
  };
};
